var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0144 8.57544C16.6134 8.17462 15.9633 8.17476 15.5625 8.57544C15.1614 8.97654 15.1614 9.6265 15.5626 10.0276L19.5079 13.9727L8.08328 13.9738C7.51627 13.9739 7.05673 14.4335 7.05673 15.0007C7.05686 15.5677 7.51641 16.0272 8.08342 16.0272L19.5084 16.0261L15.5622 19.972C15.1613 20.3729 15.1613 21.0232 15.5622 21.424C15.7628 21.6244 16.0255 21.7247 16.2883 21.7247C16.551 21.7247 16.8137 21.6244 17.0142 21.4241L22.7129 15.7256C22.9055 15.5331 23.0137 15.2721 23.0137 14.9996C23.0135 14.7272 22.9054 14.4663 22.7128 14.2734L17.0144 8.57544Z",
    fill: "url(#paint0_linear_28_4258)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_4258",
    x1: 23.0137,
    y1: 13.6548,
    x2: 7.03328,
    y2: 13.1752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F17AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC02F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.2581aaa92e8216607dfa7cba9e79dcc5.svg";
export { ForwardRef as ReactComponent };